
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend} from 'chart.js';
import {Bar} from 'react-chartjs-2';


import {Col, Row} from "react-bootstrap";

export const options = {
    plugins    : {
        title : {
            display: false,
            text   : 'Submits on Last Two Weeks',
        },
        legend: {
            display: false
        }
    },
    responsive : true,
    interaction: {
        intersect: false,
    },
    scales     : {
        x: {
            stacked: true,
        },
        y: {
            stacked: true,
        },
    },
};



ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);





const Channels = ({data}) => {

    return <>
        <Row className="d-flex align-items-center mb-3">
            <Col lg={6}>
                <h6>Last Submits</h6>
                <p>Overview of last month's submits</p>
            </Col>
            <Col lg={6} className="text-end">
                {/*<InputDate
                    range={[pastDate.toISODate(), currentDate.toISODate()]}
                    placeholder="Choose date"
                />*/}
            </Col>
        </Row>
        {data && <Bar options={options} data={data}/>}
    </>
}

export default Channels;